<template>
  <div class="header-inner">
    <div class="text-section">
      <h2 class="title">{{ headerTitle }}</h2>
      <BreadCrumb :item="headerTitle"/>
    </div>
    <div class="user-actions">
      <el-dropdown size="large" trigger="click">
        <span class="el-dropdown-link">
            <el-avatar size="" class="user-avatar" :src="userAvatar"/>
            <span class="user-fio">{{ name }}</span>
            <img width="12" src="../assets/images/icons/arrow-up.png" alt="^"/>
        </span>
        <template #dropdown>
          <el-dropdown-menu class="dropdown-menu">
            <!--            <el-dropdown-item class="dropdown-item">-->
            <!--              <span class="user-setting">-->
            <!--                <img src="../assets/images/user-setting.svg" alt="User-setting"/>-->
            <!--              </span>-->
            <!--              <span>Foydalanuvchi sozlamalari</span>-->
            <!--            </el-dropdown-item>-->
            <!--            <el-dropdown-item class="dropdown-item">-->
            <!--              <img class="user" width="30" src="../assets/images/user-avatar.png" alt="User"/>-->
            <!--              Shaxsiy kabinet-->
            <!--            </el-dropdown-item>-->
            <el-dropdown-item class="dropdown-item" @click="logOut">
              <span class="logout-icon">
                <img src="../assets/images/icons/arrow-left.svg" alt="LogOut"/>
              </span>
              Tizimdan chiqish
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import {ElMessage, ElMessageBox} from 'element-plus'

export default {
  name: "HeaderMain",
  components: {BreadCrumb},
  data() {
    return {
      userAvatar: require('../assets/images/user-avatar.png')
    }
  },
  computed: {
    headerTitle() {
      return this.$store.state.headerTitle.toString()
    },
    name() {
      return this.$store.state.role;
    },
    isCollapsed() {
      return this.$store.state.collapsed
    }
  },
  methods: {
    onClickCollapse() {
      this.$store.commit("updateCollapsed", !this.$store.state.collapsed)
    },
    logOut() {
      ElMessageBox.confirm(
          'Tizimdan chiqishni istaysizmi?',
          'Ogohlantirish',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Yoq',
            type: 'warning',
          }
      ).then(() => {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }).catch(() => {
        ElMessage({
          showClose: true,
          message: 'Tizimda qolganingiz uchun tashakkur',
        })
      })
    }
  }
}
</script>

<style scoped lang="css">
.header-inner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-inner .text-section > .title {
  font-size: 20px;
  color: #000;
  font-family: "Montserrat-Bold", sans-serif;
  padding-bottom: 11px;
}

.collapse-wrapper.collapse {
  transform: rotate(180deg);
  margin-top: -8px;
}

.user-actions {
  display: flex;
  align-items: center;
}

.user-actions > .user-avatar {
  width: 30px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.el-dropdown-link > .user-fio {
  margin: 0 10px;
  color: #65648E;
  font-size: 16px;
  user-select: none;
}

.locale-switcher, .user-setting {
  margin-right: 20px;
}

.dropdown-menu {
  padding: 20px 0;
}

.dropdown-menu /deep/ .dropdown-item {
  height: 50px;
  margin-top: 10px;
}

.dropdown-menu /deep/ .dropdown-item .logout-icon {
  border: 1px solid #7B839E;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px 1px;
  border-radius: 5px;
  margin-right: 20px;
}

.dropdown-menu /deep/ .dropdown-item .logout-icon > img {
  opacity: 0.6;
}

.dropdown-menu /deep/ .dropdown-item > .user {
  opacity: 0.6;
  margin-right: 10px;
}


</style>